import { render, staticRenderFns } from "./MduiDialog.vue?vue&type=template&id=4b6891ec"
import script from "./MduiDialog.vue?vue&type=script&lang=js"
export * from "./MduiDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports